// Modèles
import { CriteriaBase } from '@/shared/models/CriteriaBase.model';

// Énumération.
import { EtatEnvoiVesta } from '@/shared/enums/EtatEnvoiVesta.enum';

/**
 * Modèle de filtres de recherche pour les envois vesta.
 */
export class EnvoiVestaCriteria extends CriteriaBase {
    /**
     * Critères sur l'état de l'envoi vesta.
     */
    public etatEnvoiVesta: EtatEnvoiVesta | null = null;

    /**
     * Date de début pour la recherche sur la date de la facture.
     */
    public dateDebut: string = '';

    /**
     * Date de fin pour la recherche sur la date de la facture.
     */
    public dateFin: string = '';

    /**
     * Critères sur le numéro de facture.
     */
    public factureNumero: string = '';

    /**
     * Critères sur le nom de l'installation.
     */
    public nomInstallation: string = '';
}
